import { apiGet, apiPut, apiPost, apiDelete } from 'services/api';

// TODO: remove this, all are by default 'my' entities
export async function fetchMyEntities(entityName) {
  return apiGet(`/user/me/${entityName}`);
}

export async function fetchEntities(schemaId, query) {
  return apiGet(`/table/${schemaId}`, {query});
}

export async function fetchEntity(schemaId, id) {
  return apiGet(`/table/${schemaId}/${id}`);
}

export async function createEntity(schemaId, entity) {
  return apiPost(`/table/${schemaId}`, { body: entity });
}

export async function saveEntity(schemaId, entity) {
  return apiPut(`/table/${schemaId}/${entity.id}`, { body: entity });
}

export async function saveOrCreateEntity(schemaId, entity) {
  return (entity.id ? saveEntity : createEntity)(schemaId, entity);
}

export async function deleteEntity(schemaId, id) {
  return apiDelete(`/table/${schemaId}/${id}`);
}
